import { createContext, useEffect } from 'react'
import { useItemsCounted } from 'hooks/useItems/useItemsCounted'
import { useApi } from 'hooks/useApi/useApi'

export const CountingContext = createContext()

export const CountingProvider = ({ children, countingId }) => {
    const { itemsCounted, setItemsCounted, getItemsCounted, toggleSortOrder, sortConfig, loading, filters } = useItemsCounted({ counting_id: countingId })
    const {counting, fetchCounting, updateCounting, setCounting} = useApi()

    useEffect(() => {
        fetchCounting(countingId)
    }, [countingId])

    useEffect(() => {
        counting?.counted_items_amount && setItemsCounted(prevState => ({ ...prevState, total_amount: counting.counted_items_amount }))
    }, [counting?.counted_items_amount])

    return (
        <CountingContext.Provider value={{ 
            itemsCounted, getItemsCounted, toggleSortOrder, sortConfig, loading, filters, counting, updateCounting, setCounting, fetchCounting 
            }}>
            {children}
        </CountingContext.Provider>
    )
}

